"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshInsightWidgetHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var effects_1 = require("redux-saga/effects");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var insightsSelectors_1 = require("../../store/insights/insightsSelectors");
var widgetValidations_1 = require("./validation/widgetValidations");
var insights_1 = require("../../store/insights");
var general_1 = require("../../events/general");
var insight_1 = require("../../events/insight");
var loadInsight_1 = require("./common/loadInsight");
function refreshInsightWidgetHandler(ctx, cmd) {
    var widgets, insightWidget, insightRef, insight, newInsight;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _a.sent();
                insightWidget = widgetValidations_1.validateExistingInsightWidget(widgets, cmd, ctx);
                insightRef = insightWidget.insight;
                return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightByRef(insightRef))];
            case 2:
                insight = _a.sent();
                if (!insight) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Insight with ref " + sdk_model_1.objRefToString(insightRef) + " was not found in the store.");
                }
                return [4 /*yield*/, effects_1.call(loadInsight_1.loadInsight, ctx, insightRef)];
            case 3:
                newInsight = _a.sent();
                return [4 /*yield*/, effects_1.put(insights_1.insightsActions.upsertInsight(newInsight))];
            case 4:
                _a.sent();
                return [2 /*return*/, insight_1.insightWidgetRefreshed(ctx, newInsight, cmd.correlationId)];
        }
    });
}
exports.refreshInsightWidgetHandler = refreshInsightWidgetHandler;
//# sourceMappingURL=refreshInsightWidgetHandler.js.map